import { create } from 'zustand'
import { api } from '@/api/client'
import type { Template } from '@/types/models'

interface TemplateState {
  templates: Template[]
  loaded: boolean
  loadTemplates: () => Promise<void>
  addTemplate: (tpl: Omit<Template, 'id'>) => Promise<void>
  updateTemplate: (id: string, data: Partial<Template>) => Promise<void>
  deleteTemplate: (id: string) => Promise<void>
}

export const useTemplateStore = create<TemplateState>()((set, get) => ({
  templates: [],
  loaded: false,

  loadTemplates: async () => {
    try {
      const templatesData = await api.get<Template[]>('/api/templates')
      set({ templates: Array.isArray(templatesData) ? templatesData : [], loaded: true })
    } catch {
      set({ loaded: true })
    }
  },

  addTemplate: async (tpl) => {
    await api.post('/api/templates', tpl)
    await get().loadTemplates()
  },

  updateTemplate: async (id, data) => {
    await api.patch(`/api/templates/${id}`, data)
    await get().loadTemplates()
  },

  deleteTemplate: async (id) => {
    await api.delete(`/api/templates/${id}`)
    await get().loadTemplates()
  },
}))
